var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fill-height":"","fluid":""}},[_c('v-scroll-y-reverse-transition',{attrs:{"hide-on-leave":"","fill-height":""}},[(_vm.triggerTransition)?_c('v-container',{staticClass:"pt-0 pb-0 px-3",attrs:{"fluid":"","fill-height":"","d-block":""}},[_c('div',[_vm._t("default")],2)]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }